module.exports = __webpack_public_path__ + "img/supplier_default_logo.701b9c33.jpeg";